<div class="playlist-queue secondary-scroll" fxLayout="column" fxLayoutAlign="start stretch">
	<div class="queue-item cursor-pointer" *ngFor="let list of playList; let i=index;"
		[ngClass]="{'selected':list.streaming}" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
		(click)="selectData(list,i)">
		<div fxFlex="0 0 15px">
			<ng-container *ngIf="list.watched">
				<!-- <div class="check-box">
				<mat-icon fontSet="material-icons-outlined">check_box</mat-icon>
			</div> -->
				<div class="tick-icon">
					<mat-icon svgIcon="tick_mark"></mat-icon>
				</div>
			</ng-container>
		</div>
		<div class="queue-item-content" fxFlex="1 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
			<div fxFlex="0 0 70px">
				<div class="thumbnail">
					<img [src]="list.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
				</div>
			</div>
			<div class="queue-item-info" fxFlex="1 1 auto" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
				<p>{{ list.title }}</p>
			</div>
		</div>
	</div>
</div>
